/**
 * THE FEED LOG LAYOUT. On desktop and tablet the log itself is mounted here, by the parent route,
 * so opening a delivery never unmounts it: the grid, its scroll position and its loaded page
 * survive, and coming back costs nothing. The detail route renders over it as a side panel.
 *
 * A phone has no room for a panel beside a list, so the child takes the whole screen instead:
 * when a delivery is open, the log is not rendered at all (§13.4).
 */
import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";

import { usePlatform } from "../shell/usePlatform";
import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/deliveries");

export const Route = createFileRoute("/deliveries")({
  component: RouteComponent,
});

function RouteComponent() {
  const platform = usePlatform();
  const childOpen = useRouterState({
    select: (state) => state.location.pathname.replace(/\/$/, "") !== "/deliveries",
  });

  if (platform === "phone" && childOpen) return <Outlet />;

  return (
    <>
      <RoutePage entry={entry} />
      <Outlet />
    </>
  );
}
